import {chartColors} from '@/helpers/color-helper'

const $ = kendo.jQuery

function renderChart($container, options) {
  return new Promise(function(resolve, reject) {
    const actionName = 'getChartData'
    const chart = $('<div></div>').appendTo($container)
    const dataSourceUrl = `/api/report/FuturePastDistributedHedge/${actionName}`

    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const data = response
        buildChart(chart, data, options)
          .then(function(eChart) {
            resolve(eChart)
          })
          .catch(err => reject(err))
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

function buildChart(element, data, options) {
  return new Promise(function(resolve) {
    const viewType = options.groupType == 1 ? 'Client' : 'Counterparty'
    const ccyPair = options.ccyPair.split('_')
    const text = `Total Hedge per ${viewType} - ${ccyPair[0]}/${ccyPair[1]}`

    $(element)
      .kendoChart({
        renderAs: 'svg',
        transitions: true,
        title: {
          text: text,
          padding: {
            bottom: 14,
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            font: '10px Roboto',
          },
        },
        chartArea: {
          background: '',
        },
        dataSource: data,
        seriesDefaults: {
          type: 'pie',
          startAngle: 82,
          labels: {
            visible: true,
            template: "#= kendo.format('{0:P}', percentage)#",
            font: '10px Roboto',
            position: 'outsideEnd',
            background: 'transparent',
          },
        },
        seriesColors: chartColors(),
        series: [
          {
            field: 'total',
            categoryField: 'keyName',
          },
        ],
        tooltip: {
          visible: true,
          format: 'N0',
          template:
            "#= category # #= kendo.format('{0:N0}', value)#: #= kendo.format('{0:P}', percentage)#",
          font: '14px Roboto',
        },
        render: function() {
          resolve(element.getKendoChart())
        },
      })
      .data('kendoChart')
  })
}

export default {
  render: function($container, options) {
    return renderChart($container, options)
  },
}
